<mat-icon fontSet="{{fontSet}}" fontIcon="{{prefix}}-{{icon}}"  ></mat-icon>
